// Imports
import Vue from 'vue'
import Router from 'vue-router'
import { trailingSlash } from '../util/helpers'
import {
  layout,
  route,
} from '../util/routes'
import i18n from '../i18n'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    layout('Default', [
      route('Dashboard'),

      // Pages
      route('VM', null, 'server/vm'),
      route('BBB', null, 'server/bbb'),
      route('BBBStyles', null, 'server/styles'),
      route('LB', null, 'server/lb'),
      route('Meetings', null, 'server/meetings'),
      route('LB_BBB', null, 'server/lb/:lbId'),
      route('LMSConfig', null, 'lms/config'),
      route('UpdateLMS', null, 'lms/update'),
      route('Course', null, 'lms/course'),
      route('Student', null, 'lms/student'),
      route('Professor', null, 'lms/professor'),
      route('WebinarPlus', null, 'webinarplus/list'),
      route('WebinarPlusConfig', null, 'webinarplus/config'),
      route('WebinarPlusUsers', null, 'webinarplus/users'),
      route('Users', null, 'users'),
      route('UserPermissions', null, 'users/permissions/:userId'),
    ]),
    layout('Login',[
        route('Login', null, 'login'),
    ]),
    layout('Frame',[
        route('LearningDashboard', null, 'learningDashboard'),
    ])
  ],
})

// router.beforeEach((to, from, next) => {
//     if(to.path!='/login' && localStorage.getItem('token')==undefined)
//         return next('/login');
//     else if(to.path=='/login')
//         return next();
//     else
//         return next()
//         // to.path.endsWith('/') ? next() : next(trailingSlash(to.path))
// })

export default router
